import React, { useEffect, useState } from 'react';

import { observer } from 'mobx-react-lite';
import { useTranslation, gameConfigStore } from '@pascal/pascal-core';
import { limitsAndPayoutsStore } from '../../../store/limitsAndPayoutsStore';
import { limitsTranslationKeys } from '../../../enums/limitsTranslationKeys';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';

const LimitAndPayouts = observer(({ isFromRules }) => {
  const { limitsPayouts } = limitsAndPayoutsStore;
  const { limits: { additionalLimits } = {} } = gameConfigStore;
  const { currencySymbolOrCode } = userInfoStore;
  const [changedAdditionalLimits, setChangedAdditionalLimits] = useState(null);
  const t = useTranslation();

  useEffect(() => {
    if (isFromRules) {
      const newLimits = {};
      Object.keys(additionalLimits).forEach((key) => {
        newLimits[key.toLowerCase()] = additionalLimits[key];
      });

      setChangedAdditionalLimits(newLimits);
    }
  }, [additionalLimits, isFromRules]);

  return (
    <div className='lim-pay-pop-holder'>
      {limitsPayouts.map(({ marketType, maxLimit, minLimit, payout }) => (
        <div className='lim-pay-pop-row' key={marketType}>
          <div className='lim-pay-pop-row-col'>
            <p className='lim-pay-text'>{t(limitsTranslationKeys[marketType.toUpperCase()])}</p>
          </div>
          {!isFromRules && (
            <div className='lim-pay-pop-row-col'>
              <p className='lim-pay-text type-1'>
                {minLimit}-{maxLimit}
              </p>
            </div>
          )}
          <div className='lim-pay-pop-row-col'>
            <p className='lim-pay-text'>
              {isFromRules ? currencySymbolOrCode : ''}
              {isFromRules ? ' ' : ''}
              {isFromRules && changedAdditionalLimits
                ? changedAdditionalLimits[marketType.toLowerCase()].maxWin
                : payout}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
});

export default LimitAndPayouts;
